const SPECIAL_CHARACTERS = [".", ",", ";", ":", "=", "*", "+", "-", "{", "}", "[", "]", "¿", "?", "¡", "!", "(", ")", "/", "|", "\\", "\""]
const normalizeQuotes = (text) => text
    .replace(/’/g, "'")
    .replace(/“/g, '"')
    .replace(/”/g, '"')
    .replace(/«/g, '"')
    .replace(/»/g, '"')

export class Decoder {
    constructor(config = {}) {
        this.keySensitive = config.keySensitive ?? false;
        this.pile = []
    }

    encode(entryStr) {
        if (this.keySensitive) {
            return entryStr;
        }

        const words = entryStr.split(" ");
        const response = [];

        words.forEach(word => {
            const encodeWord = this._encodeWord(word);

            response.push(encodeWord);

            this.pile.push({
                encode: encodeWord,
                decode: word
            });
        });

        return response.join(" ");
    }

    decode(entryStr) {
        if (this.keySensitive) {
            return entryStr;
        }

        const words = entryStr.split(" ");
        const result = words.map(word => {
            const encodeWord = this._encodeWord(word);
            const index = this.pile.findIndex(item => item.encode === encodeWord);

            if (index === -1) {
                return word;
            }

            const decodeWord = this.pile[index].decode;

            this.pile.splice(index, 1);

            return decodeWord
        });

        return result.join(" ");
    }

    _encodeWord(str) {
        const normalized = str.trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
        const characters = normalizeQuotes(normalized).split("");

        return characters.filter(char => {
            return !SPECIAL_CHARACTERS.includes(char)
        }).join("");
    }
}